export default {
      id: "common__geozone_polygon-usage",
      viewBox: "0 0 34 21",
      url: __webpack_public_path__ + "img/icons.svg#common__geozone_polygon",
      toString: function () {
        return this.url;
      }
    }